module.exports = __webpack_public_path__ + "img/ds_lingxian.3e3e2efe.png";